import { typeGuard } from '@/lib/utils';
import type {
  RumEvent,
  RumEventDomainContext,
  RumResourceEvent,
} from '@datadog/browser-rum';

// Not compatible with all browsers yet
// https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType#browser_compatibility
declare global {
  interface PerformanceEntry {
    deliveryType?: string;
  }
}

function isResourceFromDiskCache(event: RumResourceEvent): boolean {
  return (
    event.resource.transfer_size === 0 &&
    event.resource.decoded_body_size !== undefined &&
    event.resource.decoded_body_size > 0
  );
}

function isRumResourceEvent(event: RumEvent): event is RumResourceEvent {
  return (
    event.type === 'resource' &&
    event.resource.type !== 'fetch' &&
    event.resource.type !== 'xhr'
  );
}

function isNextJSInternalError(event: RumEvent, context: any): boolean {
  return event.type === 'error' && context?.error?.digest;
}

export function beforeSend(
  event: RumEvent,
  context: RumEventDomainContext
): boolean {
  if (
    isRumResourceEvent(event) &&
    event.context != null &&
    typeGuard(context, 'performanceEntry')
  ) {
    const isFromDiskCache = isResourceFromDiskCache(event);
    event.context.diskCache = isFromDiskCache;
    // Not compatible with all browsers yet
    // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType#browser_compatibility
    event.context.deliveryType =
      context.performanceEntry?.deliveryType ?? undefined;
  }
  if (isNextJSInternalError(event, context)) {
    return false;
  }
  return true;
}
